import { gql, TypedDocumentNode } from '@apollo/client';

import { RealFiatAssets, HistoryPeriodEnumKeys } from '@libs/types';
import { DefaultApiResponse, DefaultArg, assetFragment } from '@libs/graphql';

import { UserBalance } from 'src/types';

export type GetTotalBalanceForUserType = {
  total: number;
  crypto: number;
  fiat: number;
  totalPercentageChange?: number;
  totalValueChange?: number;
};

export type GetTotalBalanceResponse = {
  getTotalBalanceForUser: DefaultApiResponse<GetTotalBalanceForUserType>;
};
export type GetTotalBalanceNewResponse = {
  getTotalBalanceForUserNew: DefaultApiResponse<GetTotalBalanceForUserType>;
};

export type GetTotalBalanceArgs = {
  assetCode: string | number;
  historyInterval?: number;
};

export const getTotalBalanceQuery: TypedDocumentNode<
  GetTotalBalanceResponse,
  DefaultArg<GetTotalBalanceArgs>
> = gql`
  query GetTotalBalance($record: TotalBalanceRecord!) {
    getTotalBalanceForUser(record: $record) {
      total
      crypto
      fiat
      totalPercentageChange
      totalValueChange
    }
  }
`;
export const getTotalBalanceNewQuery: TypedDocumentNode<
  GetTotalBalanceResponse,
  DefaultArg<{ valueAssetCode: RealFiatAssets; period: HistoryPeriodEnumKeys }>
> = gql`
  query GetTotalBalanceForUserNew($record: AssetsRateChangeRecord!) {
    getTotalBalanceForUser: getTotalBalanceForUserNew(record: $record) {
      totalValueChange
      totalPercentageChange
      total
      fiat
      crypto
    }
  }
`;

// User Balances
export type GetUserBalancesRes = {
  getUserBalances: DefaultApiResponse<UserBalance[]>;
};

export const getUserBalances: TypedDocumentNode<GetUserBalancesRes> = gql`
  query GetDefaultAccountBalancesForUser {
    getUserBalances: getDefaultAccountBalancesForUser {
      id
      amount
      blockedAmount
      availableAmount
      asset {
        ...assetFields
      }
    }
  }

  ${assetFragment}
`;
